export const socialsData = {
    github: 'https://github.com/NusrathJahan58',
    facebook: 'https://www.facebook.com/nusha.jahan.7/',
    linkedIn: 'https://www.linkedin.com/in/nusrath-jahan-7568b91b3/',
    instagram: 'https://www.instagram.com/dreamfrosty_nusrath/',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: '',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}